import {t} from '@lingui/core/macro'

import {cleanError} from '#/lib/strings/errors'

/**
 * Plain-English text for a failed publish.
 *
 * When a record fails the PDS's schema check, the PDS reports it in the schema
 * library's own terms, for example "Invalid site.standard.document record:
 * blob too big (maximum 1000000, got 1974419) at
 * $.writes[0].record.coverImage", and `cleanError` passes that through
 * unchanged. Those messages are replaced here; everything else goes to
 * `cleanError`.
 */
export function publishErrorMessage(err: unknown): string {
  if (!err) {
    return cleanError(err)
  }
  // oxlint-disable-next-line typescript/no-base-to-string
  const text = typeof err === 'string' ? err : err.toString()
  const isTooBig = / too big \(maximum \d+, got \d+\)/.test(text)
  if (isTooBig && /\.coverImage\b/.test(text)) {
    return t`The cover image is too large. Remove it and choose it again, and it will be resized to fit.`
  }
  if (isTooBig) {
    return t`An image in this article is too large. Replace it with a smaller one and try again.`
  }
  if (/Invalid [\w.]+ record:/.test(text)) {
    return t`This article couldn't be published because part of it isn't in the form Sunnahsky expects. Please try again.`
  }
  return cleanError(err)
}
